import { RegisterForm } from "../../../components/auth/register/RegisterForm.tsx";

export default function RegisterPage() {
  return (
    <div>
      <RegisterForm />
    </div>
  );
}
